import React, { useState } from "react";
import { Col, Row, Modal } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { useNavigate } from 'react-router-dom';
import StoreCallVisitForm from "./StoreCallVisitForm";

const GeneralInfo = ({ info, additional_info }) => {
  let navigate = useNavigate();
  const [showScheduleModal, setShowScheduleModal] = useState(false);

  return (
    <>
      <Row>
        <Col>
          <dl className="row">
            <dt className="col-sm-4"> SAP </dt>
            <dd className="col-sm-8">
              <a href={`/stores/${info?.id}`} target="_blank">{info?.sap}</a>
            </dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4"> Store Name </dt>
            <dd className="col-sm-8">
              <a
                href={`/employees?filter={"store_sap_name":{"filterType":"text","type":"Contains","filter":"${info?.sap}"},"emp_status":{"filterType":"text","type":"contains","filter":"Active"}}`}
                target="_blank"
              >
                {info?.store_name}
              </a>
            </dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Address</dt>
            <dd className="col-sm-8">{info?.address}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Phone</dt>
            <dd className="col-sm-8">
              <a href={info?.store_phone ? `tel:${info.store_phone.replace(/[^\d]/g, '')}` : undefined}>
                {info?.store_phone}
              </a>
            </dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Store Hours</dt>
            <dd className="col-sm-8">{info?.store_hrours}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">District</dt>
            <dd className="col-sm-8">
              <a
                href={`/stores?filter=${encodeURIComponent(
                  JSON.stringify({
                    active: { filterType: "text", type: "equals", filter: "0" },
                    market: { filterType: "text", type: "contains", filter: `["${info?.market_name}"]` },
                  })
                )}`}
                target="_blank"
              >
                {info?.market_name}
              </a>
            </dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Region</dt>
            <dd className="col-sm-8">{info?.region_name}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Acquisition Dealer</dt>
            <dd className="col-sm-8">{info?.acquisition_dealer_name}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Store Classification</dt>
            <dd className="col-sm-8">{info?.store_classification_name}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Store Type</dt>
            <dd className="col-sm-8">{info?.channel_name}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Supported By</dt>
            <dd className="col-sm-8">{info?.supported_by}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Camera System</dt>
            <dd className="col-sm-8">{additional_info?.data?.[0]?.Camera_System}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Network Support</dt>
            <dd className="col-sm-8">{additional_info?.data?.[0]?.Network_Support}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Phone Support</dt>
            <dd className="col-sm-8">{additional_info?.data?.[0]?.Phone_Support}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-4">Printer Support</dt>
            <dd className="col-sm-8">{additional_info?.data?.[0]?.Printer_Support}</dd>
          </dl>

          {/* ── Store Schedule ─────────────────────────────────── */}
          <dl className="row">
            <dt className="col-sm-4">Store Schedule</dt>
            <dd className="col-sm-8">
              <span
                onClick={() => setShowScheduleModal(true)}
                style={{
                  color: "var(--color-primary-green)",
                  cursor: "pointer",
                  fontWeight: "600",
                  textDecoration: "underline",
                }}
              >
                New Store Call/Visit
              </span>
            </dd>
          </dl>

        </Col>
        <Col></Col>
      </Row>

      {/* ── Staff Table ──────────────────────────────────────── */}
      <Row>
        <Col md={8}>
          <Table striped bordered hover size="sm">
            <thead>
              <tr>
                <th>Title</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Work Phone</th>
                <th>Personal Phone</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>RSM</td>
                <td>{info?.rsm.first_name}</td>
                <td>{info?.rsm.last_name}</td>
                <td>{info?.rsm.Phone}</td>
                <td>{info?.rsm.personal_phone}</td>
                <td><a href={`mailto:${info?.rsm.Email}`}>{info?.rsm.Email}</a></td>
              </tr>
              <tr>
                <td>DSOM</td>
                <td>{info?.dsom.first_name}</td>
                <td>{info?.dsom.last_name}</td>
                <td>
                  <a href={info?.dsom.Phone ? `tel:${info.dsom.Phone.replace(/[^\d]/g, '')}` : undefined}>
                    {info?.dsom.Phone}
                  </a>
                </td>
                <td>{info?.dsom.personal_phone}</td>
                <td><a href={`mailto:${info?.dsom.Email}`}>{info?.dsom.Email}</a></td>
              </tr>
              <tr>
                <td>DOSO</td>
                <td>{info?.doso.first_name}</td>
                <td>{info?.doso.last_name}</td>
                <td>
                  <a href={info?.doso.Phone ? `tel:${info.doso.Phone.replace(/[^\d]/g, '')}` : undefined}>
                    {info?.doso.Phone}
                  </a>
                </td>
                <td>{info?.doso.personal_phone}</td>
                <td><a href={`mailto:${info?.doso.Email}`}>{info?.doso.Email}</a></td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>

      {/* ── Store Call/Visit Modal ───────────────────────────── */}
      <Modal
        show={showScheduleModal}
        onHide={() => setShowScheduleModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <span style={{ marginRight: "8px" }}>🏪</span> */}
            New Store Call/Visit
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <StoreCallVisitForm
            handleClose={() => setShowScheduleModal(false)}
            onSuccess={() => setShowScheduleModal(false)}
            storeSap={info?.id}
            storeName={info?.store_name}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GeneralInfo;
